<template>
  <div class="lines-bg">
    <page-header :content="pageHeading"/>
    <div class="wrapper mx-auto px-4 md:px-8 xl:px-0 pb-16 story-content">
      <body-copy v-if="page.fields.body" :content="page.fields.body.content" class="opacity-0" v-animate-onscroll="'animated fadeIn'"/>
    </div>
  </div>

</template>

<script>
import * as moment from "moment"
import BodyCopy from '~/components/common/BodyCopy'
import PageHeader from '~/components/common/PageHeader'

export default {

  components: {
    BodyCopy,
    PageHeader,
  },
  async validate({ $api, params }) {
    return await $api.getPage(params.slug, 'article')
  },
  async asyncData({ $api, params }) {
    return {
      page: await $api.getPage(params.slug, 'article')
    }
  },
  head() {
    return this.$metadata(this.page)
  },
  methods: {
    date(created) {
      return moment(created).format('MMM D')
    }
  },
  computed: {
    pageHeading() {
      return {
        heading: this.page.fields.title,
        image: this.page.fields.featureImageDesktop,
        links: [
          {
            fields: {
              internalLink: true,
              title: 'Stories',
              url: '/stories/'
            }
          },
          {
            fields: {
              internalLink: true,
              title: this.page.fields.title,
              url: '/stories/'+this.page.fields.slug+'/'
            }
          },
        ]
      }
    }
  }
}
</script>

<style lang="scss">
</style>
